import { Outlet, useLocation } from '@tanstack/react-router';
import { HappyFlowTemplate } from './HappyFlowTemplate';
import { useBoundStore } from '@Store/index.ts';
import { useMemo } from 'react';
import { routesModel } from '@Router/router.consts';
import { LayoutsMap } from '@Router/router.types.ts';
import { PasswordlessDesktopSideBar } from '@Components/happyFlowTemplate/passwordlessDesktopSideBar/passwordlessDesktopSideBar';
import { EdgeCaseTemplate } from './EdgeCaseTemplate';
import { BasicTemplate } from '@Layout/BasicTemplate.tsx';

export const LayoutSwitcher = () => {
  const { pathname } = useLocation();
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());

  const activeLayoutType = useMemo(() => {
    const activeRoute = Object.values(routesModel).find((route) => route.path === pathname);
    if (!activeRoute) return LayoutsMap.DEFAULT;
    else return activeRoute.layoutType;
  }, [pathname]);

  return (
    <>
      {activeLayoutType === LayoutsMap.DEFAULT && (
        <div key='default-layout' className='w-full h-full flex flex-row items-center fade-in'>
          {isEmbedded && <PasswordlessDesktopSideBar />}
          <Outlet />
        </div>
      )}
      {activeLayoutType === LayoutsMap.HAPPY_FLOW && <HappyFlowTemplate />}
      {activeLayoutType === LayoutsMap.EDGE_CASE && <EdgeCaseTemplate />}
      {activeLayoutType === LayoutsMap.BASIC && <BasicTemplate />}
    </>
  );
};
